/**
 * 进行分组
 * @param groups 组别
 * @param nums 每组个数
 * @returns 分组结果
 */
export default function grouping() {
  var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var nums = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  if (groups.length === 0 || nums <= 1) return groups;
  var result = [];
  var str = '';

  for (var i = 0; i < groups.length; i++) {
    if (str.length === nums) {
      result.push(str);
      str = '';
    }

    str += groups[i];

    if (i === groups.length - 1) {
      result.push(str);
    }
  }

  return result;
}